<template lang="es">
    <div>
         <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" md="12" sm="12" xs="12">
                        <v-row>
                            <v-col cols="12" sm="12" md="7" class="pb-0 mb-0">
                            Asignaci&oacute;n Aprobadores / Revisores
                            </v-col>
                                                
                            <v-col cols="12" sm="12" md="12" class="mt-0 pt-0">
                            <small class="mt-0 pt-0" v-if="nombreInstitucion">{{nombreInstitucion}}</small>
                            </v-col>
                        </v-row>
                    </v-col>            
                </v-row>

                <v-row class="col-md-12">
                    <v-col cols="12" md="4" sm="4" xs="12" >
                        <v-select
                            v-model="periodoMedicionId"
                            :items="periodos"
                            :loading="ddPeriodosLoading"
                            dense
                            outlined
                            label="Periodo de medición"
                            item-text="anioMedicion"
                            item-value="id"
                            return-object
                            :no-data-text="periodos!=null ? 'Selecciona un periodo' : 'No se han encontrado periodos'"
                            menu-props="auto"
                        ></v-select>
                    </v-col>

                    <v-col cols="12" md="5" sm="5" xs="12">
                        <v-select
                            v-model="departamentoId"
                            :items="deptos"
                            class="required"
                            dense
                            outlined
                            :loading="ddDeptosLoading"
                            label="Departamento"
                            item-text="nombreDepartamento"
                            item-value="id"
                            return-object
                            menu-props="auto"
                            @change="obtnenerMunicipiosPorDepto();"
                            :rules="[
                                selectRequired(
                                    'Departamento'
                                )
                            ]"
                            
                        >
                            <template slot='selection' slot-scope='{ item }'>
                                    <v-row>
                                        <v-col cols="12">
                                            {{ item.codigo }} - {{ item.nombreDepartamento }}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    <v-row>
                                        <v-col cols="12">
                                            {{ item.codigo }} - {{ item.nombreDepartamento }} <br/> 
                                        </v-col>
                                    </v-row>
                                </template>
                        </v-select>
                    </v-col>
                    <!--@change="obtenerAprobadoresRevisoresAsignados(); obtnenerMunicipiosPorDepto()"-->
                
                    <v-col cols="12" sm="3" md="3" xs="12">
                        <v-btn
                            color="primary"
                            class="mb-2 float-right bg-light-blue"
                            @click="obtenerAprobadoresRevisoresAsignados();"
                        >
                            Buscar
                            <v-icon right>mdi-magnify</v-icon>
                        </v-btn>
                    </v-col> 
                </v-row>

                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>
            
                        
            <v-card-text>

              

              <v-row v-if="periodoMedicionId.id === 0 || departamentoId.id < 1">
                    <v-col cols="12">
                        <v-alert
                            text
                            prominent
                            type="error"
                            icon="mdi-alert"
                            dense
                            small
                            >
                                <p class="mt-3">Para poder asignar aprobadores y revisores, debes de seleccionar un periodo de medición y departamento</p> 
                            </v-alert>
                    </v-col>
              </v-row>

                            
            

                <v-row class="dd-flex aalign-end flex-ccolumn mb-4">

                    <v-col cols="12" sm="6" md="6" xs="12" class="mt-0 pt-0">
                        <v-btn
                            color="primary"
                            class="mb-2 float-left bg-light-blue"
                            :disabled="periodoMedicionId.id === 0 || departamentoId.id < 1"
                            @click="modalNueva"
                        >
                            Asignar Aprobador/Revisor
                        </v-btn>
                    </v-col> 
                    
                    <v-col  md="6" sm="6" xs="12" class="pt-0 pb-1 align-end">
                        <v-text-field
                            append-icon="mdi-magnify"
                            outlined
                            dense
                            v-model="filtroBusqueda"
                            label="Buscar"
                            maxlength="100"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-data-table
                    :headers="headers"
                    :items="usuariosAsignados"
                    item-key="Id"
                    class="elevation-0"
                    :loading="tableAsignadosLoading"
                    no-data-text="No hay datos para mostrar"
                    :search="filtroBusqueda"
                    :items-per-page="10"
                    :footer-props="{
                        showFirstLastPage: true,
                        firstIcon: 'mdi-page-first',
                        lastIcon: 'mdi-page-last',
                        prevIcon: 'mdi-chevron-left',
                        nextIcon: 'mdi-chevron-right',
                        'items-per-page-text':'Registros por página',
                        pageText: '{0}-{1} de {2}' 
                    }"
                    dense
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.codigo != null ? `${item.codigo} - ` : ''}} {{item.nombreMunicipio }}</td>
                            <td>
                                <div v-if="item.nombreAprobador != null">
                                    {{`${item.nombreAprobador}`}}
                                </div>
                                                                    
                                <v-chip v-else
                                    class="ma-2"
                                    :color="item.estadosId === 1 ? 'teal' : 'orange' "
                                    text-color="black"
                                    small
                                    outlined
                                >
                                    No asignado(a)
                                </v-chip>
                            </td>

                            <td>
                                <div v-if="item.correoAprobador != null">
                                    {{`${item.correoAprobador}`}}
                                </div>
                                                                    
                                <div v-else>
                                    - - -
                                </div>
                                
                            </td>

                            <td>
                                <div v-if="item.nombreRevisor != null">
                                    {{`${item.nombreRevisor}`}}
                                </div>
                                                                    
                                <v-chip v-else
                                    class="ma-2"
                                    :color="item.estadosId === 1 ? 'teal' : 'orange' "
                                    text-color="black"
                                    small
                                    outlined
                                >
                                    No asignado(a)
                                </v-chip>
                                
                            </td>

                            <td>
                                <div v-if="item.correoRevisor != null">
                                    {{`${item.correoRevisor}`}}
                                </div>
                                                                    
                                <div v-else>
                                    - - -
                                </div>
                                
                            </td>
                            <!--<td>
                                <v-chip
                                        class="ma-2"
                                        :color="item.estadosId === 1 ? 'teal' : 'orange' "
                                        text-color="white"
                                        small
                                    >
                                        {{item.estado}}
                                </v-chip>
                            </td>-->
                            <td> 
                                <v-btn v-if="(currentRoles && currentRoles.includes(1) || currentRoles && currentRoles.includes(16)) && item.asignacionId != null" :disabled="periodoMedicionId.id === 0" class="ma-2" small tile outlined color="indigo" @click="obtenerAsignacion(item.asignacionId)">
                                    <v-icon left>mdi-pencil</v-icon> Actualizar
                                </v-btn>
                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>
        <!-- Inicio:: Dialog para mostrar los datos de la etnia-->
    <v-dialog
        v-model="dialog"
        max-width="700px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                {{modalTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="asgingarAprobadorRevisorMuni"
                v-model="validForm"
                >
                <v-card-text>
                    <v-row>
                        <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                label="Periodo Medición"
                                v-model="nombreAnio"
                                :disabled="true"
                                dense
                                outlined
                            >

                            </v-text-field>
                        </v-col>

                        <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                label="Departamento"
                                v-model="nombreDepartamento"
                                :disabled="true"
                                dense
                                outlined
                            >

                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row v-if="accion===1">
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="municipiosSeleccionados"
                                :items="municipios"
                                class="required"
                                dense
                                outlined
                                :no-data-text="municipios != null ? 'Seleccione una municipalidad' : 'No se han encontrado municipios'"
                                :loading="ddMunicipiosLoading"
                                label="Seleccionar municipio(s)"
                                item-text="nombreMunicipio"
                                item-value="id"
                                multiple
                                return-object
                                chips
                                :rules="[
                                    accion===1 ? selectRequired('Municipio(s)') : true
                                ]"
                                
                            >
                            <template v-slot:prepend-item>
                                <v-list-item
                                    ripple
                                    @click="toggle"
                                    >
                                    <v-list-item-action>
                                        <v-icon :color="municipiosSeleccionados.length > 0 ? 'indigo darken-4' : ''">
                                        {{ icon }}
                                        </v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                        Seleccionar todos
                                        </v-list-item-title>
                                    </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>
                            </v-select>
                        </v-col>
                        
                    </v-row>

                    <v-row v-if="accion===2">
                        <v-col  md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                label="Municipio"
                                v-model="nombreMunicipalidad"
                                :disabled="true"
                                dense
                                outlined
                            >

                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col  md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-autocomplete
                                v-model="datosAsignacion.usuarioAprobadorId"
                                :items="aprobadores"
                                class="required"
                                dense
                                outlined
                                :loading="ddAprobadoresLoading"
                                label="Seleccionar Aprobador"
                                item-text="nombreUsuario"
                                item-value="id"
                                menu-props="auto"
                                :rules="[
                                    selectRequired(
                                        'Aprobadore'
                                    )
                                ]"
                            >
                                <template slot='selection' slot-scope='{ item }'>
                                    <v-row>
                                        <v-col cols="12">
                                            {{ item.nombreUsuario }}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    <v-row>
                                        <v-col cols="12">
                                            {{ item.nombreUsuario }} <br/> 
                                            <small class="text-overline>">{{ item.correoUsuario }}</small>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col  cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-autocomplete
                                v-model="datosAsignacion.usuarioRevisorId"
                                :items="revisores"
                                class="required"
                                menu-props="auto"
                                dense
                                outlined
                                :loading="ddDeptosLoading"
                                label="Seleccionar Revisor"
                                item-text="nombreUsuario"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'Revisor'
                                    )
                                ]"
                            >
                                <template slot='selection' slot-scope='{ item }'>
                                    <v-row>
                                        <v-col cols="12">{{item.nombreUsuario}}</v-col>
                                    </v-row>
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    <v-row>
                                        <v-col cols="12">
                                            {{ item.nombreUsuario }} <br/> 
                                            <small class="text-overline>">{{ item.correoUsuario }}</small>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-autocomplete>
                        </v-col> 
                       
                    </v-row>                    
                    <!--<v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                        </v-col>
                    </v-row>-->

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialog = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="(!validForm || municipiosSeleccionados.length <=0) && accion===1" 
                                :loading="btnRegistroLoading"                         
                            >
                                {{btnRegistroText}}
                            </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import validations from "@/core/untils/validations.js";
import { mapGetters } from "vuex";
import { API_BASE_URL } from "@/core/services/api.service";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";


import { OBTENER_PERIODOS } from "@/core/services/store/catalogos/periodomedicion.module";
import { OBTENER_DEPARTAMENTOS} from "@/core/services/store/catalogos/departamento.module";
import { OBTENER_MUNICIPIOS_POR_DEPTO } from "@/core/services/store/catalogos/municipio.module";

import { OBTENER_APROBADORES_ACTIVOS_INSTITUCION, OBTENER_REVISORES_ACTIVOS_INSTITUCION, OBTENER_APROBADORES_REVISORES_ASIGNADOS_MUNI_PERIODO, ASIGNAR_APROBADORES_REVISORES_MUNI_PERIODO, OBTENER_ASIGNACION_APROBADOR_REVISOR_MUNI, ACTUALIZAR_ASIGNACION_APROBADORES_REVISORES_MUNI_PERIODO } from "@/core/services/store/usuarios/usuarioinstitucional.module";

import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";
export default {
    name: "AsingAprobadorRevisor",
    components: {
    SnackAlert,
    DialogLoader
    },
        data() {
        return {
            baseIntUrl:'',
            tableLoading: false,
            tableAsignadosLoading:false,
            validForm:false,
            periodoMedicionId: {id: 0, anioMedicion: 0},
            ddDeptosLoading:false,
            ddMunicipiosLoading:false,
            ddAprobadoresLoading: false,
            ddRevisoresLoading: false,
            itemName : "Usuarios Institucionales",
            dialog: false,
            dialogResetPass:false,
            modalTitle: 'Asignar',
            btnRegistroLoading: false,
            btnResetPassLoading:false,
            dialogLoaderVisible: false,
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Asignar',
            accion: 1,
            roles: [],
            deptos:[],
            periodos: [],
            aprobadores:[],
            revisores:[],
            ddPeriodosLoading:false,
            departamentoId:{id: 0, nombreDepartamento: ''},
            municipios: [],
            municipioId: 0,
            municipiosSeleccionados:[],
            nombreMunicipalidad:'',
            usuariosAsignados:[],
            nombreDepartamento:'',
            nombreAnio: '',
            usuarios: [],
            departamentos: [],
            switchItemEstado: true,
            nombreUsuario:'',
            idUsuario:0,
            filtroBusqueda: '',
            nombreInstitucion: null,
            institucionId: 0,
            datosAsignacion: {
                periodoMedicionId:0,
                estadosId:1,
                usuarioRevisorId:0,
                usuarioAprobadorId:0,
                listaMunicipios:[],
                institucionId: 0
            },
            ...validations
        } 
    },
    methods: {

        toggle () {
            this.$nextTick(() => {
            if (this.likesAllMunicipios) {
                this.municipiosSeleccionados = []
            } else {
                this.municipiosSeleccionados = this.municipios.slice()
            }
            })
        },
        modalNueva(){
            this.accion =1;
            this.modalTitle='Asignar Aprobador y Revisor';
            this.btnRegistroText='Asignar';
            /*if(parseInt(window.localStorage.getItem('creadorDepartamentoId'))){
                this.obtnenerMunicipiosPorDepto();
            }*/
            this.nombreAnio = this.periodoMedicionId.anioMedicion;
            this.nombreDepartamento = this.departamentoId.nombreDepartamento;
            this.dialog=true;
            this.archivoExiste=false;
        },

        resetForm(){
            //this.$refs.form.reset();
            this.datosAsignacion={
                periodoMedicionId:0,
                estadosId:1,
                usuarioRevisorId:0,
                usuarioAprobadorId:0,
                listaMunicipios:[]
            };
            this.archivoExiste=false;
            this.archivoCargado=false;
            this.switchItemEstado = true;
            this.municipiosSeleccionados=[];
            //this.municipios=[];

             if(parseInt(window.localStorage.getItem('creadorDepartamentoId'))){
                this.datosAsignacion.departamentoInformadorId = parseInt(window.localStorage.getItem('creadorDepartamentoId'));
             }
        },

        //!Obtener los periodos para la tabla
        obtnenerPeriodosMedicion(){
            this.ddPeriodosLoading = true;
            this.periodos=[];
            
            this.$store
                .dispatch(OBTENER_PERIODOS)
                .then(() => {
                    this.periodos = this.$store.state.periodomedicion.periodos;
                    this.ddPeriodosLoading =false;
                })
                .catch(() => {
                    this.ddPeriodosLoading = false;
                });

        },


        //!Obtener los departamentos para la tabla
        async obtnenerDepartamentos(){
            this.ddDeptosLoading = true;
            this.deptos=[];
            
            await this.$store
            .dispatch(OBTENER_DEPARTAMENTOS,1)
            .then(res => {
                if(res.status==200){
                    this.deptos = this.$store.state.departamento.departamentos;
                }
                this.ddDeptosLoading =false;
            //console.log(this.etnias)
            })
            .catch(() => {
                this.ddDeptosLoading = false;
            });

        },


        //!Obtener Aprobadores / Revisores asignados por Municipio, periodo e institucion
        async obtenerAprobadoresRevisoresAsignados(){

            this.tableAsignadosLoading=true;
            this.usuariosAsignados=[];
            
            await this.$store
                .dispatch(OBTENER_APROBADORES_REVISORES_ASIGNADOS_MUNI_PERIODO, {deptoId: this.departamentoId.id, periodoId: this.periodoMedicionId.id, institucionId: this.institucionId})
                .then(res => {
                    if(res.status==200){
                        this.usuariosAsignados = this.$store.state.usuarioinstitucional.usuariosAprobadoresRevisoresAsignados;
                    }
                    this.tableAsignadosLoading=false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.tableAsignadosLoading=false;
                });

                
        },

        
        //!Obtener las etnias para la tabla
        async obtnenerMunicipiosPorDepto(){
           // console.log("dsfsdf")
            //this.departamentoId = this.datosAsignacion.departamentosId;
            //this.ddMunicipiosLoading = true;
            this.ddMunicipiosLoading=true;
            this.municipios=[];
            
            await this.$store
                .dispatch(OBTENER_MUNICIPIOS_POR_DEPTO, {departamentoId: this.departamentoId.id, estadoId: 1})
                .then(res => {
                    if(res.status==200){
                        this.municipios = this.$store.state.municipio.municipios;
                    }
                    this.ddMunicipiosLoading=false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.ddMunicipiosLoading=false;
                });

        },

        //!Obtener revisores por institucion
        async obtenerRevisoresInstitucion(){

            this.ddRevisoresLoading = true;
            this.revisores=[];
            
            await this.$store
            .dispatch(OBTENER_REVISORES_ACTIVOS_INSTITUCION,this.institucionId)
            .then(res => {
                if(res.status==200){
                    this.revisores = this.$store.state.usuarioinstitucional.usuariosRevisoresInstitucionales;
                }
                 this.ddRevisoresLoading = false;
            })
            .catch(() => {
                this.ddRevisoresLoading = false;
            });
        },


        //!Obtener aprobadores por institucion
        async obtenerAprobadoresInstitucion(){
            this.ddAprobadoresLoading = true;
            this.aprobadores=[];
            await this.$store
            .dispatch(OBTENER_APROBADORES_ACTIVOS_INSTITUCION,this.institucionId)
            .then(res => {
                if(res.status==200){
                    this.aprobadores = this.$store.state.usuarioinstitucional.usuariosAprobadoresInstitucionales;
                }
                 this.ddAprobadoresLoading = false;
            })
            .catch(() => {
                this.ddAprobadoresLoading = false;
            });
        },

        mostarModalAsignacion(AnioMedicion, Municipio, Id){
            this.nombreAnio = AnioMedicion;
            this.nombreDepartamento = Municipio;
            this.municipioId=Id;
            this.dialog=true;
        },
        
        //!Asignar Aprobador/Revisor a Municipalidad
        async asgingarAprobadorRevisorMuni(){
            //Pasar el objeto de municipios a un array con los id de los mismos para asignar
            //this.datosAsignacion.listaMunicipios = this.municipiosSeleccionados.map(a => a.id);

            //this.datosAsignacion.listaMunicipios = this.municipiosSeleccionados;
            this.btnRegistroLoading=true;
            //console.log(this.municipiosSeleccionados)
            
            if(this.accion ===1){
                this.datosAsignacion.listaMunicipios = this.municipiosSeleccionados.map(function(item){
                    return {
                        municipiosId: item.id,
                    };
                });

                this.datosAsignacion.periodoMedicionId = this.periodoMedicionId.id;
                this.datosAsignacion.institucionId = this.institucionId;
                
               

                //!Asignar el aprobador y revisor al (los) municipio(s) seleccionado(s)
                this.$store
                .dispatch(ASIGNAR_APROBADORES_REVISORES_MUNI_PERIODO, this.datosAsignacion)
                .then(res => {
                    //console.log(res)
                    if(res.status===200){
                        this.obtenerAprobadoresRevisoresAsignados();
                        this.dialog=false;
                        // this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                         if(res.data!=null){
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            /* let noAsignados = "";
                            
                           res.data.forEach(noAsignado => {
                                noAsignados += `${noAsignado.nombreMunicipio}, `
                                //this.$refs.snackalert.SnackbarShow('warning', 'Mensaje', noAsignado.nombreMunicipio + ", ya se encuentra asignado para el periodo seleccionado.");
                            });
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message+ ": "  + noAsignados);
                            */
                            
                        } else {
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                        }
                        this.resetForm();
                        //this.switchItemEstado = true;
                    } else {
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    }
                    this.btnRegistroLoading=false;
                })
                .catch(error => {
                    //console.log(error)
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                    this.btnRegistroLoading=false;
                });
            }
            else if(this.accion===2){
                //console.log("actualizando.....")
                this.$store
                .dispatch(ACTUALIZAR_ASIGNACION_APROBADORES_REVISORES_MUNI_PERIODO, this.datosAsignacion)
                .then(res => {
                     console.log(res)
                    if(res.status===200){
                        this.obtenerAprobadoresRevisoresAsignados();
                        this.dialog=false;
                        /*if(res.data!=null){
                           
                            //let noAsignados = JSON.parse(JSON.stringify(res.data));
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            res.data.forEach(noAsignado => {
                                this.$refs.snackalert.SnackbarShow('warning', 'Mensaje', noAsignado.nombreMunicipio + ", ya se encuentra asignado para el periodo seleccionado.");
                            });

                            
                        } else {
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                        }*/

                        this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                        this.resetForm();
                        //this.switchItemEstado = true;
                    } else {
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    }
                    this.btnRegistroLoading=false;
                })
                .catch(error => {
                    //console.log(error)
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                    this.btnRegistroLoading=false;
                });
            }

            //console.log(listaMunicipios)
        },


        //!Obtener una asignación ya registrada para mostrar su informacion
        async obtenerAsignacion(Id){
            this.dialogLoaderVisible=true;
            //this.datosItem.id = Id;
            
            this.modalTitle='Actualizar Asignación';
            this.btnRegistroText='Actualizar Asignación';

            this.$store
                .dispatch(OBTENER_ASIGNACION_APROBADOR_REVISOR_MUNI, Id)
                .then(res => {
                   
                    if(res.status===200){
                        this.datosAsignacion = this.$store.state.usuarioinstitucional.usuarioInstitucional;
                        this.nombreMunicipalidad = this.datosAsignacion.nombreMunicipio;
                        this.nombreDepartamento = this.datosAsignacion.nombreDepartamento;
                        this.nombreAnio = this.datosAsignacion.anioMedicion;
                        let municipioAsignado = [{id:  this.datosAsignacion.municipiosId}];
                        // municipioAsignado.id =  this.datosAsignacion.municipiosId;
                        
                         console.log(municipioAsignado)
                        //this.datosAsignacion.listaMunicipios = municipioAsignado;
                        this.datosAsignacion.listaMunicipios = municipioAsignado.map(function(item){
                            return {
                                municipiosId: item.id,
                            };
                        });

                        console.log(this.datosAsignacion)
                        this.accion=2;

                        //console.log(this.datosItem)
                        //this.datosAsignacion.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                        this.dialog = true;
                    } else {
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    }
                    //console.log(this.datosItem)
                   
                    this.dialogLoaderVisible = false;
                })
                .catch(error => {
                    this.dialogLoaderVisible = false;
                    console.log(error)
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                });

        },
      
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Usuarios" },
            { title: "Asignación" }
        ]);
    },

    created(){
        this.obtnenerDepartamentos();
        this.obtnenerPeriodosMedicion();

        this.baseIntUrl = API_BASE_URL;


        //console.log(window.localStorage.getItem('rolId'))
        let stRoles = window.localStorage.getItem('roles');
        
        if(stRoles.includes(1)){
            if(parseInt(window.localStorage.getItem('institucionId'))){
                this.institucionId = parseInt(window.localStorage.getItem('institucionId'));
                this.datosAsignacion.institucionId = this.institucionId;
                
            }
        } else if (stRoles.includes(6)){
            this.institucionId = 0;
        }
        this.nombreInstitucion = window.localStorage.getItem('institucionNombre');

        this.obtenerRevisoresInstitucion();
        this.obtenerAprobadoresInstitucion();
    },

    computed: {
         likesAllMunicipios () {
            return this.municipiosSeleccionados.length === this.municipios.length
        },
        likesSomeMunicipio () {
            return this.municipiosSeleccionados.length > 0 && !this.likesAllMunicipios
        },
        icon () {
            if (this.likesAllMunicipios) return 'mdi-close-box'
            if (this.likesSomeMunicipio) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        //...mapGetters(["getInterfaceBaseUrl"]),
        ...mapGetters(["currentUser"]),
        ...mapGetters(["currentRoles"]),

        headers() {
            return [
                {
                    text: "Municipio",
                    value: "nombreMunicipio"
                },
                {
                    text: "Aprobador",
                    value: "nombreUsuarioAprobador"
                },
                {
                    text: "Correo Aprobador",
                    value: "correoAprobador"
                },
                {
                    text: "Revisor",
                    value: "nombreUsuarioRevisor"
                },
                {
                    text: "Correo Revisor",
                    value: "correoRevisor"
                },
                /*{
                    text: "Estado",
                    value: "estadosId"
                },*/
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        }
    }
}
</script>
<style lang="scss">
    .v-select{
        &.v-input--dense{ 
            .v-chip {
            margin: 4px 4px 4px 4px !important;
            }
        }
    }
</style>